module.exports = __webpack_public_path__ + "img/chev_down.44ec03bc.svg";